// extracted by mini-css-extract-plugin
export var table = "_x9-0";